export default {
    /**
     * Datos añadidos a data por el mixin:
     * - statusTypesOptions: array con tipos de estatus
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            statusTypesOptions: []
        };
    },
    methods: {
        /**
         * Load Status types
         */
        loadStatusesTypesOptions() {
            const statusTypes = this.$t(`interveners.fatca.status`);
            this.statusTypesOptions = Object.entries(statusTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de estatus en la variable
     * `this.statusTypesOptions`
     */
    beforeMount() {
        this.loadStatusesTypesOptions();
    }
};

